// /global → the v3 Global Desk (foreign / ADR universe), reached from the More
// sheet. Thin shim like the other v2/pages screens.
import { GlobalDesk } from '@/v2/v3/GlobalDesk'

export function V2GlobalPage() {
  return <GlobalDesk />
}
